<template>
    <div class="relative inline-block group mx-2">
        <button @click="toggleDarkMode"
            class="p-2.5 rounded-full text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150 ease-in-out"
            aria-label="Toggle dark mode">
            <font-awesome-icon icon="moon" class="fa-lg" v-if="isDarkMode === 'light'" />
            <font-awesome-icon icon="sun" class="fa-lg" v-else />
        </button>

        <div
            class="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition duration-300 bg-gray-700 dark:bg-gray-800 text-white text-xs py-1.5 px-3 rounded-xl whitespace-nowrap z-50 shadow-md pointer-events-none">
            {{ message }}
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const isDarkMode = ref('light');
const message = ref('Dark Mode');

const applyDarkMode = (mode) => {
    if (mode === 'dark') {
        message.value = 'Light Mode';
        document.documentElement.classList.add('dark');
        localStorage.setItem('theme', 'dark');
        isDarkMode.value = 'dark';
    } else {
        message.value = 'Dark Mode';
        document.documentElement.classList.remove('dark');
        localStorage.setItem('theme', 'light');
        isDarkMode.value = 'light';
    }
};

const toggleDarkMode = () => {
    applyDarkMode(isDarkMode.value === 'dark' ? 'light' : 'dark');
};

onMounted(() => {
    // 1. الفحص الأول: هل المستخدم اختار ثيم محدد سابقاً وحفظه في المتصفح؟
    const savedTheme = localStorage.getItem('theme');

    if (savedTheme === 'dark' || savedTheme === 'light') {
        console.log('Applying saved theme:', savedTheme);
        applyDarkMode(savedTheme);
    } else {
        // 2. الفحص الثاني: إذا لم يكن هناك ثيم محفوظ، نتبع نظام تشغيل الجهاز
        const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        applyDarkMode(prefersDark ? 'dark' : 'light');
    }
});
</script>